var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upload-list"},[_vm._l((_vm.filsMax),function(item,index){return [_c('upload-file',{key:index,attrs:{"src":_vm.srcList[index],"accept":_vm.accept,"path":_vm.path,"disabled":""},on:{"success":val => _vm.success(val, index)}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }